// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"35bf0aad","498":"5086bfa1","545":"4acd7379","787":"e423377e"}[chunkId] + ".chunk.js";
};